import { Engine, Scene } from "@babylonjs/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE } from "../../AppConfig";
import {
    RENDERQUALITYFACTOR,
    SUN_ANGLE,
    DRAWER_TOOLSET_EXPANDED,
    BEAMS_AND_POSTS_TOOL,
    THREED_MINI_MODE,
    TOOL_DRAWER_WIDTH,
    THREED_MODE,
    THREED_MINI_HEIGHT,
    THREED_MINI_WIDTH,
    toggleDesigner,
    updateDesigner
} from "../../redux_store/appState";
import _debounce from "lodash/debounce";
import { updateSkylights3D, zoomAll3D } from "./Babylon3D";
import { updateLayout2D, updateLayout3D } from "../../redux_store/appStateHelper";
import { GetShapeUpdateString, GetColourUpdateString } from "./PaperFunctionHelper";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { IconButton } from "@material-ui/core";
import * as Paper from "./PaperFunctions";

function getVideoCardInfo() {
    const gl = document.createElement("canvas").getContext("webgl");
    if (!gl) {
        return {
            error: "no webgl",
        };
    }
    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    return debugInfo
        ? {
              vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
              renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
          }
        : {
              error: "no WEBGL_debug_renderer_info",
          };
}

export default (props) => {
    const dispatch = useDispatch();
    const reactCanvas = useRef(null);
    const {
        antialias,
        engineOptions,
        adaptToDeviceRatio,
        sceneOptions,
        onRender,
        onSceneReady,
        onLoadModel,
        threeDMode,
        modelFileName,
        backgroundMode,
        toggleEnvironment,
        changeMeshGroupColour,
        updateColours,
        ...rest
    } = props;

    // const devicePixelRatio = window.devicePixelRatio;

    const job = useSelector((state) => state.job);
    const obj = useSelector((state) => state.job.App.current_OBJ);
    const toolopen = useSelector((state) => state.app.designer.designer3D?.[DRAWER_TOOLSET_EXPANDED]);
    const tool_drawer_width = useSelector((state) => state.app.designer?.[TOOL_DRAWER_WIDTH]);
    const threed_mini_mode = useSelector((state) => state.app.designer?.[THREED_MINI_MODE]);
    // 
    window.threed_mini_mode = threed_mini_mode;
    const threed_mini_width = useSelector((state) => state.app.designer?.[THREED_MINI_WIDTH]);
    const threed_mini_height = useSelector((state) => state.app.designer?.[THREED_MINI_HEIGHT]);
    const threed_mode = useSelector((state) => state.app.designer?.[THREED_MODE]);

    let renderQuality = props?.app?.designer?.designer3D?.[RENDERQUALITYFACTOR];
    if (!renderQuality) renderQuality = 1;
    let sunAngle = props?.app?.designer?.designer3D?.[SUN_ANGLE];
    if (!sunAngle) sunAngle = 1;
    let base_render_factor = window.dedicated_GPU ? 1.5 : 3.0; /// higher is less intense, this is set for intel and integrated

    let renderFactor = base_render_factor - 0.8 * base_render_factor * (renderQuality / 10);

    const [loaded, setLoaded] = useState(false);
    const [scene, setScene] = useState(null);
    const [reload, setReload] = useState(false);
    const [last_loaded_model_hash, setlast_loaded_model_hash] = useState(null);
    const [last_loaded_model_filename, setlast_loaded_model_filename] = useState(null);

    const [debounce3dtimeout, setdebounce3dtimeout] = useState(100);

    let colour_change = GetColourUpdateString(true);

    let shape_update = GetShapeUpdateString(true);

    
    const [newHeight, setNewHeight] = React.useState(threed_mini_height);
    const [newWidth, setNewWidth] = React.useState(threed_mini_width);

    const handleMousedown = (e) => {
        // 
        window.isResizing3D = true;
    };

    React.useEffect(() => {
        const setFromEvent = (e) => {
            if (!window.isResizing3D) return;

            let offsetTop = e.clientY;
            let minHeight = 200;
            let maxHeight = document.body.offsetHeight - 100;
            if (window.threed_mini_mode === "rotated") {
                offsetTop = document.body.offsetWidth-e.clientX;
                minHeight = 500;
                maxHeight = document.body.offsetWidth - 300;
            }
            if (offsetTop < minHeight) {
                if (offsetTop < 100) {
                    //hide panel
                    // dispatch(updateDesigner(APP.TOOL_DRAWER_HIDE, true));
                    offsetTop = minHeight;
                } else {
                    offsetTop = minHeight;
                }
            }
            if (offsetTop > maxHeight) {
                offsetTop = maxHeight;
            }
            if (window.threed_mini_mode === "rotated") {
                setNewWidth(offsetTop);
                window.threed_mini_width = offsetTop;
            }
            else {
                setNewHeight(offsetTop);
                window.threed_mini_height = offsetTop;
            } // not a fan of using window global, but was taking too long to work out how to pass to handleMouseUo below.
            // dispatch(APP.updateDesigner(APP.TOOL_DRAWER_WIDTH, offsetRight)); // too slow
        };
        window.addEventListener("mousemove", setFromEvent);

        return () => {
            window.removeEventListener("mousemove", setFromEvent);
        };
    }, []);

    React.useEffect(() => {
        const handleMouseUo = (e) => {
            window.isResizing3D = false;
            if (window.threed_mini_mode === "rotated") {
                if (window.threed_mini_width) {
                    dispatch(updateDesigner(THREED_MINI_WIDTH, window.threed_mini_width));
                }
            }
            else {

                if (window.threed_mini_height) {
                    dispatch(updateDesigner(THREED_MINI_HEIGHT, window.threed_mini_height));
                }
            }
            // setIsResizing(false)
        };
        window.addEventListener("mouseup", handleMouseUo);

        return () => {
            window.removeEventListener("mouseup", handleMouseUo);
        };
    }, []);

    useEffect(() => {
        if (loaded && scene) {
            Paper.zoomAll();
            if (last_loaded_model_filename) zoomAll3D();
        }
        if (threed_mini_mode === "rotated") {
            if (threed_mini_width && threed_mini_width !== newWidth) {
                setNewWidth(threed_mini_height);
            }
        }
        else {
            if (threed_mini_height && threed_mini_height !== newHeight) {
                setNewHeight(threed_mini_height);
            }
        }
    }, [threed_mini_height, threed_mini_width, threeDMode, threed_mini_mode]); // eslint-disable-next-line react-hooks/exhaustive-deps

    useEffect(() => {
        // 
        if (threeDMode) {
            
            setlast_loaded_model_hash(shape_update);
            update3D();

            
        }
    }, [shape_update]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const update3D = React.useCallback(
        _debounce((name) => {
            dispatch(updateLayout3D());
            setdebounce3dtimeout(1000);
            setTimeout(function () {
                setdebounce3dtimeout(100);
            }, 1000);
        }, debounce3dtimeout),
        []
    );

    useEffect(() => {
        if (loaded && scene) {
            if (threeDMode) {
                scene.getEngine().runRenderLoop(() => {
                    if (typeof onRender === "function") {
                        onRender(scene, dispatch, props.job);
                    }
                    scene.render();
                });

                setTimeout(() => {
                    var success = updateSkylights3D();
                    if (!success) {
                        setTimeout(() => {
                            success = updateSkylights3D();
                            if (!success) {
                                setTimeout(() => {
                                    var success = updateSkylights3D();
                                    updateColours(true);
                                }, 700);
                            } else {
                                updateColours(true);
                            }
                        }, 500);
                    } else {
                        updateColours(true);
                    }
                }, 300);

                
            } else {
                scene.getEngine().stopRenderLoop();
                
            }
        }
    }, [threeDMode]); // eslint-disable-next-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (loaded && scene) {
            if (typeof toggleEnvironment === "function") {
                toggleEnvironment(backgroundMode);
            }
            scene.render();
        }
    }, [backgroundMode]); // eslint-disable-next-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (loaded && scene) {
            update3DColours();
        }
    }, [colour_change]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const update3DColours = React.useCallback(
        _debounce((name) => {
            
            updateColours();
        }, 100),
        []
    );

    useEffect(() => {
        if (loaded && scene && threeDMode) {
            let this_modelFileName = obj;
            if (!modelFileName) this_modelFileName = "model.obj";
            if (this_modelFileName) {
                if (typeof onLoadModel === "function" && last_loaded_model_filename !== this_modelFileName) {
                    // this_modelFileName = "637414874908878580_5937.obj";
                    onLoadModel({
                        scene,
                        model: this_modelFileName,
                        url_base: API_BASE() + "obj/" + props?.job?.id + "/",
                        dispatch: dispatch,
                        job: props?.job,
                    });
                    setlast_loaded_model_filename(this_modelFileName);
                }
                if (last_loaded_model_hash !== shape_update) {
                    setlast_loaded_model_hash(shape_update);
                    dispatch(updateLayout3D());
                }
                scene.render();
            } else {
                if (!last_loaded_model_hash) {
                    setlast_loaded_model_hash(shape_update);
                    dispatch(updateLayout3D());
                } else if (last_loaded_model_hash !== shape_update) {
                    setlast_loaded_model_hash(shape_update);
                    dispatch(updateLayout3D());
                }
            }
        }
        // else {
        //     
        //     setTimeout(function () {
        //         setReload(!reload);
        //     }, 500);
        // }
    }, [obj, threeDMode, reload]);

    useEffect(() => {
        if (window) {
            const resize = () => {
                if (scene) {
                    // scene.getEngine().setHardwareScalingLevel(renderFactor * window.devicePixelRatio);

                    scene.getEngine().setHardwareScalingLevel(renderFactor / window.devicePixelRatio);
                    scene.getEngine().resize();
                }
            };
            window.addEventListener("resize", resize);

            return () => {
                window.removeEventListener("resize", resize);
            };
        }
    }, [scene]);

    useEffect(() => {
        if (window) {
            if (scene) {
                scene.getEngine().setHardwareScalingLevel(renderFactor / window.devicePixelRatio);
                scene.getEngine().resize();
                // 
            }
        }
    }, [renderQuality, threed_mini_mode, tool_drawer_width, threed_mini_height, threed_mini_width]);

    useEffect(() => {
        if (window) {
            if (scene) {
                // window._scene_data.direction_light.direction.x = sunAngle;
                // 
            }
        }
    }, [sunAngle]);

    useEffect(() => {
        // 
        if (!loaded && reactCanvas?.current) {
            // window.devicePixelRatio

            let gpu_data = getVideoCardInfo();
            window.dedicated_GPU = false;
            if (gpu_data && gpu_data?.vendor.includes("NVIDIA")) {
                
                window.dedicated_GPU = true;
            }

            setLoaded(true);
            const engine = new Engine(reactCanvas?.current, antialias, engineOptions, adaptToDeviceRatio);
            const scene = new Scene(engine, sceneOptions);
            scene.getEngine().setHardwareScalingLevel(renderFactor / window.devicePixelRatio);
            setScene(scene);
            if (scene.isReady()) {
                props.onSceneReady({ scene, job: props.job, dispatch });
            } else {
                scene.onReadyObservable.addOnce((scene) => props.onSceneReady({ scene, job: props.job, dispatch }));
            }

            // engine.runRenderLoop(() => {
            //     if (typeof onRender === 'function') {
            //         onRender(scene);
            //     }
            //     scene.render();
            // })
        }

        return () => {
            if (scene !== null) {
                scene.dispose();
            }
        };
    }, [reactCanvas]);

    return (
        <>
            {threed_mode && (
                <IconButton
                    style={false?{
                        zIndex: 2,
                        display: "block",
                        position: "absolute",
                        right: (tool_drawer_width+10) + "px",
                        bottom: "27vh",
                        transition: "all 1s ease"
                    }:{
                        zIndex: 2,
                        display: "block",
                        position: "absolute",
                        right: (tool_drawer_width+10) + "px",
                        top: "95px",
                        transition: "all 1s ease"
                    }}
                    aria-label="delete"
                    size="small"
                    onClick={() => {
                        dispatch(toggleDesigner(THREED_MINI_MODE)).then( () => {
                            if (!threed_mini_mode) {
                                Paper.zoomAll();
                                zoomAll3D();
                            }
                        }
                        )
                    }}
                >
                    {threed_mini_mode?
                    <FullscreenIcon
                    style={{
                        color: "rgb(28 28 28)",
                    }}
                    fontSize="48px" />:<FullscreenExitIcon 
                    style={{
                        color: "rgb(28 28 28)",
                    }}
                    fontSize="48px" />
                }
                </IconButton>
            )}
            <canvas
                style={
                    threed_mini_mode && threed_mode
                        ? {
                              zIndex: 1,
                              display: "block",
                              position: "absolute",
                              left: threed_mini_mode === "rotated"?"unset":"80px",
                              right: (tool_drawer_width*0.75) + "px",
                              top: "60px",
                              backgroundColor: "rgba(255, 255, 255, 255)",
                              width: threed_mini_mode === "rotated"?(threed_mini_width-(tool_drawer_width*0.75)) + "px":"-webkit-fill-available",
                              height: threed_mini_mode === "rotated"?"100%":(threed_mini_height-60) + "px",
                              // height: "600px",
                              color: "#000",
                              border: "2px solid rgba(0, 0, 0, 0.15)"
                              // transition: "visibility 0.3s, opacity 0.3s linear",
                          }
                        : {
                              zIndex: 0,
                              display: "block",
                              position: "absolute",
                              top: "0px",
                              right: "0px",
                              left: "0px",
                              backgroundColor: "rgba(255, 255, 255, 255)",
                              width: "100%",
                              height: "100%",
                              // height: "600px",
                              color: "#000",
                              // transition: "visibility 0.3s, opacity 0.3s linear",
                          }
                }
                ref={reactCanvas}
                // {...rest}
            />

{threed_mini_mode === "rotated" && threed_mode &&
            <div
                    id="dragger_3d"
                    onMouseDown={(event) => {
                        handleMousedown(event);
                    }}
            style={{
                // height: "100%",
                width: "3px",
                    cursor: "ew-resize",
                    padding: "4px 0 0",
                    borderBottom: "1px solid #ddd",
                    position: "absolute",
                    // top: newHeight + "px",
                    top: 0,
                    right: (newWidth) + "px",
                    bottom: 0,
                    zIndex: 2,
                    backgroundColor: "#c7ccd0",
                    "-webkit-user-drag": "none",
                    "&:hover": {
                        backgroundColor: "#a7aca0",
                    },
                }}
                ></div>
            }
{threed_mini_mode === true && threed_mode &&
            <div
                    id="dragger_3d"
                    onMouseDown={(event) => {
                        handleMousedown(event);
                    }}
            style={{
                height: "3px",
                // width: "100%",
                    cursor: "ns-resize",
                    padding: "4px 0 0",
                    borderBottom: "1px solid #ddd",
                    position: "absolute",
                    top: newHeight + "px",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2,
                    backgroundColor: "#c7ccd0",
                    "-webkit-user-drag": "none",
                    "&:hover": {
                        backgroundColor: "#a7aca0",
                    },
                }}
                ></div>
            }
            
        </>
    );
};
